import { render } from "./Orders.vue?vue&type=template&id=1b13bb05&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=1b13bb05&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b13bb05"

export default script